/**
 * Module-level flash state for the native onboarding auth sheet. Its
 * "account created" banner can't live in component state: better-auth
 * refetches its session store after the mutation, GuestOnlyRoute swaps its
 * Outlet for a spinner while that's pending, and the sheet unmounts —
 * wiping any local flag. A module variable survives any number of remounts
 * without touching the URL.
 *
 * The web auth screens don't need this: their confirmations are snackbars,
 * and the notistack provider sits outside the router, so an enqueued toast
 * survives those remounts on its own. The sheet keeps an in-sheet banner
 * because a toast floating outside the drawer would feel disconnected.
 *
 * Time-windowed rather than consume-once: the remount can happen more than
 * once in quick succession (navigation + session-refetch spinner), and a
 * one-shot read would be eaten by the first mount and lost by the second.
 * The window self-expires, so no cleanup is needed.
 */

const WINDOW_MS = 15_000;

let flaggedAt = 0;

export const flagAccountCreated = (): void => {
  flaggedAt = Date.now();
};

export const wasAccountJustCreated = (): boolean =>
  flaggedAt !== 0 && Date.now() - flaggedAt < WINDOW_MS;
